import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";

interface DangerousSettingWarningProps {
  showConfirmationButton: boolean;
  onConfirm: () => void;
}

export const DangerousSettingWarning: React.FC<
  DangerousSettingWarningProps
> = ({ showConfirmationButton, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Alert className="col-span-full" severity="warning">
      <p className="m-0">
        {t("views.autotractor.equipment.tractors.dangerousSettingsWarning")}
      </p>
      {showConfirmationButton && (
        <Button variant="contained" onClick={onConfirm} className="mt-4">
          {t("views.autotractor.equipment.tractors.enableEditing")}
        </Button>
      )}
    </Alert>
  );
};
